/**
 * Contadores de prueba social dinámicos.
 *
 * Todos los contadores:
 *  - Cambian cada semana automáticamente.
 *  - Son determinísticos (todas las usuarias ven el mismo número la misma semana).
 *  - No requieren backend.
 */

const START_MS = new Date('2026-01-06T00:00:00Z').getTime();
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function getWeeksElapsed(referenceDate = new Date()) {
  return Math.max(0, Math.floor((referenceDate.getTime() - START_MS) / WEEK_MS));
}

/**
 * Contador de usuarias que eligieron el plan Anual esta semana.
 * Crece ~1 por mes. Rango típico: 12-45.
 */
export function getAnnualSocialProofCount(referenceDate = new Date()) {
  const w = getWeeksElapsed(referenceDate);
  const growth = Math.floor(w / 4);
  const weeklyOffset = (w * 13 + 7) % 14;
  return Math.min(12 + growth + weeklyOffset, 45);
}

/**
 * Contador general de usuarias que compraron el plan esta semana (para landing/pricing).
 * Rango típico: 8-30. Distinto seed que el anual para que no sea el mismo número.
 */
export function getWeeklyBuyersCount(referenceDate = new Date()) {
  const w = getWeeksElapsed(referenceDate);
  const growth = Math.floor(w / 5);
  const weeklyOffset = (w * 17 + 3) % 11;
  return Math.min(8 + growth + weeklyOffset, 38);
}

/**
 * "Cupos restantes" en la semana. Rango 2-6, varía para crear urgencia.
 */
export function getRemainingSpotsCount(referenceDate = new Date()) {
  const w = getWeeksElapsed(referenceDate);
  const offset = (w * 7 + 5) % 5; // 0-4
  return 2 + offset; // 2-6
}

// ── Textos listos para renderizar ──
export function getSocialProofText(referenceDate = new Date()) {
  const n = getAnnualSocialProofCount(referenceDate);
  return `${n} usuarias eligieron el anual esta semana`;
}

export function getWeeklyBuyersText(referenceDate = new Date()) {
  const n = getWeeklyBuyersCount(referenceDate);
  return `${n} usuarias compraron esta semana`;
}

export function getRemainingSpotsText(referenceDate = new Date()) {
  const n = getRemainingSpotsCount(referenceDate);
  return `Quedan ${n} cupos esta semana`;
}
